export type Country = {
  name: string
  code: string
  currency: string
}

export const AVAILABLE_COUNTRIES = [
  {
    name: 'Mexico',
    code: 'MX',
    currency: 'MXN',
  },
  {
    name: 'Argentina',
    code: 'AR',
    currency: 'ARS',
  },
  {
    name: 'Colombia',
    code: 'CO',
    currency: 'COP',
  },
  {
    name: 'Brazil',
    code: 'BR',
    currency: 'BRL',
  },
] satisfies Country[]

// list is generated from https://github.com/moment/moment-timezone/blob/develop/data/meta/latest.json

export const countriesList: Record<string, string> = {
  'Europe/Andorra': 'AD',
  'Asia/Dubai': 'TF',
  'Asia/Kabul': 'AF',
  'America/Puerto_Rico': 'VI',
  'America/Antigua': 'AG',
  'America/Anguilla': 'AI',
  'Europe/Tirane': 'AL',
  'Asia/Yerevan': 'AM',
  'Africa/Lagos': 'NG',
  'Africa/Luanda': 'AO',
  'Antarctica/Casey': 'AQ',
  'Antarctica/Davis': 'AQ',
  'Antarctica/Mawson': 'AQ',
  'Antarctica/Palmer': 'AQ',
  'Antarctica/Rothera': 'AQ',
  'Antarctica/Troll': 'AQ',
  'Asia/Urumqi': 'CN',
  'Pacific/Auckland': 'NZ',
  'Pacific/Port_Moresby': 'PG',
  'Asia/Riyadh': 'YE',
  'Antarctica/McMurdo': 'AQ',
  'Antarctica/DumontDUrville': 'AQ',
  'Antarctica/Syowa': 'AQ',
  'Antarctica/Vostok': 'AQ',
  'America/Buenos_Aires': 'AR',
  'America/Cordoba': 'AR',
  'America/Salta': 'AR',
  'America/Jujuy': 'AR',
  'America/Tucuman': 'AR',
  'America/Catamarca': 'AR',
  'America/La_Rioja': 'AR',
  'America/San_Juan': 'AR',
  'America/Mendoza': 'AR',
  'America/San_Luis': 'AR',
  'America/Rio_Gallegos': 'AR',
  'America/Ushuaia': 'AR',
  'America/Argentina/Buenos_Aires': 'AR',
  'America/Argentina/Cordoba': 'AR',
  'America/Argentina/Salta': 'AR',
  'America/Argentina/Jujuy': 'AR',
  'America/Argentina/Tucuman': 'AR',
  'America/Argentina/Catamarca': 'AR',
  'America/Argentina/La_Rioja': 'AR',
  'America/Argentina/San_Juan': 'AR',
  'America/Argentina/Mendoza': 'AR',
  'America/Argentina/San_Luis': 'AR',
  'America/Argentina/Rio_Gallegos': 'AR',
  'America/Argentina/Ushuaia': 'AR',
  'Pacific/Pago_Pago': 'UM',
  'Europe/Vienna': 'AT',
  'Australia/Lord_Howe': 'AU',
  'Antarctica/Macquarie': 'AU',
  'Australia/Hobart': 'AU',
  'Australia/Melbourne': 'AU',
  'Australia/Sydney': 'AU',
  'Australia/Broken_Hill': 'AU',
  'Australia/Brisbane': 'AU',
  'Australia/Lindeman': 'AU',
  'Australia/Adelaide': 'AU',
  'Australia/Darwin': 'AU',
  'Australia/Perth': 'AU',
  'Australia/Eucla': 'AU',
  'America/Aruba': 'AW',
  'Europe/Helsinki': 'FI',
  'Europe/Mariehamn': 'AX',
  'Asia/Baku': 'AZ',
  'Europe/Belgrade': 'SI',
  'Europe/Sarajevo': 'BA',
  'America/Barbados': 'BB',
  'Asia/Dhaka': 'BD',
  'Europe/Brussels': 'NL',
  'Africa/Abidjan': 'TG',
  'Africa/Ouagadougou': 'BF',
  'Europe/Sofia': 'BG',
  'Asia/Qatar': 'QA',
  'Asia/Bahrain': 'BH',
  'Africa/Maputo': 'ZW',
  'Africa/Bujumbura': 'BI',
  'Africa/Porto-Novo': 'BJ',
  'America/St_Barthelemy': 'BL',
  'Atlantic/Bermuda': 'BM',
  'Asia/Kuching': 'MY',
  'Asia/Brunei': 'BN',
  'America/La_Paz': 'BO',
  'America/Kralendijk': 'BQ',
  'America/Noronha': 'BR',
  'America/Belem': 'BR',
  'America/Fortaleza': 'BR',
  'America/Recife': 'BR',
  'America/Araguaina': 'BR',
  'America/Maceio': 'BR',
  'America/Bahia': 'BR',
  'America/Sao_Paulo': 'BR',
  'America/Campo_Grande': 'BR',
  'America/Cuiaba': 'BR',
  'America/Santarem': 'BR',
  'America/Porto_Velho': 'BR',
  'America/Boa_Vista': 'BR',
  'America/Manaus': 'BR',
  'America/Eirunepe': 'BR',
  'America/Rio_Branco': 'BR',
  'America/Toronto': 'CA',
  'America/Nassau': 'BS',
  'Asia/Thimphu': 'BT',
  'Africa/Gaborone': 'BW',
  'Europe/Minsk': 'BY',
  'America/Belize': 'BZ',
  'America/St_Johns': 'CA',
  'America/Halifax': 'CA',
  'America/Glace_Bay': 'CA',
  'America/Moncton': 'CA',
  'America/Goose_Bay': 'CA',
  'America/Iqaluit': 'CA',
  'America/Winnipeg': 'CA',
  'America/Resolute': 'CA',
  'America/Rankin_Inlet': 'CA',
  'America/Regina': 'CA',
  'America/Swift_Current': 'CA',
  'America/Edmonton': 'CA',
  'America/Cambridge_Bay': 'CA',
  'America/Inuvik': 'CA',
  'America/Dawson_Creek': 'CA',
  'America/Fort_Nelson': 'CA',
  'America/Whitehorse': 'CA',
  'America/Dawson': 'CA',
  'America/Vancouver': 'CA',
  'America/Panama': 'PA',
  'America/Phoenix': 'US',
  'America/Blanc-Sablon': 'CA',
  'America/Atikokan': 'CA',
  'America/Creston': 'CA',
  'Asia/Yangon': 'MM',
  'Indian/Cocos': 'CC',
  'Africa/Kinshasa': 'CD',
  'Africa/Lubumbashi': 'CD',
  'Africa/Bangui': 'CF',
  'Africa/Brazzaville': 'CG',
  'Europe/Zurich': 'LI',
  'Pacific/Rarotonga': 'CK',
  'America/Santiago': 'CL',
  'America/Punta_Arenas': 'CL',
  'Pacific/Easter': 'CL',
  'Africa/Douala': 'CM',
  'Asia/Shanghai': 'CN',
  'America/Bogota': 'CO',
  'America/Costa_Rica': 'CR',
  'America/Havana': 'CU',
  'Atlantic/Cape_Verde': 'CV',
  'America/Curacao': 'CW',
  'Asia/Bangkok': 'VN',
  'Indian/Christmas': 'CX',
  'Asia/Nicosia': 'CY',
  'Asia/Famagusta': 'CY',
  'Europe/Prague': 'SK',
  'Europe/Berlin': 'SJ',
  'Europe/Busingen': 'DE',
  'Africa/Nairobi': 'YT',
  'Africa/Djibouti': 'DJ',
  'Europe/Copenhagen': 'DK',
  'America/Dominica': 'DM',
  'America/Santo_Domingo': 'DO',
  'Africa/Algiers': 'DZ',
  'America/Guayaquil': 'EC',
  'Pacific/Galapagos': 'EC',
  'Europe/Tallinn': 'EE',
  'Africa/Cairo': 'EG',
  'Africa/El_Aaiun': 'EH',
  'Africa/Asmara': 'ER',
  'Europe/Madrid': 'ES',
  'Africa/Ceuta': 'ES',
  'Atlantic/Canary': 'ES',
  'Africa/Addis_Ababa': 'ET',
  'Pacific/Fiji': 'FJ',
  'Atlantic/Stanley': 'FK',
  'Pacific/Kosrae': 'FM',
  'Pacific/Guadalcanal': 'SB',
  'Pacific/Chuuk': 'FM',
  'Pacific/Pohnpei': 'FM',
  'Atlantic/Faroe': 'FO',
  'Europe/Paris': 'MC',
  'Africa/Libreville': 'GA',
  'Europe/London': 'JE',
  'America/Grenada': 'GD',
  'Asia/Tbilisi': 'GE',
  'America/Cayenne': 'GF',
  'Europe/Guernsey': 'GG',
  'Africa/Accra': 'GH',
  'Europe/Gibraltar': 'GI',
  'America/Nuuk': 'GL',
  'America/Danmarkshavn': 'GL',
  'America/Scoresbysund': 'GL',
  'America/Thule': 'GL',
  'Africa/Banjul': 'GM',
  'Africa/Conakry': 'GN',
  'America/Guadeloupe': 'GP',
  'Africa/Malabo': 'GQ',
  'Europe/Athens': 'GR',
  'Atlantic/South_Georgia': 'GS',
  'America/Guatemala': 'GT',
  'Pacific/Guam': 'MP',
  'Africa/Bissau': 'GW',
  'America/Guyana': 'GY',
  'Asia/Hong_Kong': 'HK',
  'America/Tegucigalpa': 'HN',
  'Europe/Zagreb': 'HR',
  'America/Port-au-Prince': 'HT',
  'Europe/Budapest': 'HU',
  'Asia/Jakarta': 'ID',
  'Asia/Pontianak': 'ID',
  'Asia/Makassar': 'ID',
  'Asia/Jayapura': 'ID',
  'Europe/Dublin': 'IE',
  'Asia/Jerusalem': 'IL',
  'Europe/Isle_of_Man': 'IM',
  'Asia/Kolkata': 'IN',
  'Indian/Chagos': 'IO',
  'Asia/Baghdad': 'IQ',
  'Asia/Tehran': 'IR',
  'Atlantic/Reykjavik': 'IS',
  'Europe/Rome': 'VA',
  'Europe/Jersey': 'JE',
  'America/Jamaica': 'JM',
  'Asia/Amman': 'JO',
  'Asia/Tokyo': 'JP',
  'Asia/Bishkek': 'KG',
  'Asia/Phnom_Penh': 'KH',
  'Pacific/Tarawa': 'WF',
  'Pacific/Kanton': 'KI',
  'Pacific/Kiritimati': 'KI',
  'Indian/Comoro': 'KM',
  'America/St_Kitts': 'KN',
  'Asia/Pyongyang': 'KP',
  'Asia/Seoul': 'KR',
  'Asia/Kuwait': 'KW',
  'America/Cayman': 'KY',
  'Asia/Almaty': 'KZ',
  'Asia/Qyzylorda': 'KZ',
  'Asia/Qostanay': 'KZ',
  'Asia/Aqtobe': 'KZ',
  'Asia/Aqtau': 'KZ',
  'Asia/Atyrau': 'KZ',
  'Asia/Oral': 'KZ',
  'Asia/Vientiane': 'LA',
  'Asia/Beirut': 'LB',
  'America/St_Lucia': 'LC',
  'Europe/Vaduz': 'LI',
  'Asia/Colombo': 'LK',
  'Africa/Monrovia': 'LR',
  'Africa/Johannesburg': 'ZA',
  'Africa/Maseru': 'LS',
  'Europe/Vilnius': 'LT',
  'Europe/Luxembourg': 'LU',
  'Europe/Riga': 'LV',
  'Africa/Tripoli': 'LY',
  'Africa/Casablanca': 'MA',
  'Europe/Monaco': 'MC',
  'Europe/Chisinau': 'MD',
  'Europe/Podgorica': 'ME',
  'America/Marigot': 'MF',
  'Indian/Antananarivo': 'MG',
  'Pacific/Kwajalein': 'MH',
  'Pacific/Majuro': 'MH',
  'Europe/Skopje': 'MK',
  'Africa/Bamako': 'ML',
  'Asia/Ulaanbaatar': 'MN',
  'Asia/Hovd': 'MN',
  'Asia/Choibalsan': 'MN',
  'Asia/Macau': 'MO',
  'Pacific/Saipan': 'MP',
  'America/Martinique': 'MQ',
  'Africa/Nouakchott': 'MR',
  'America/Montserrat': 'MS',
  'Europe/Malta': 'MT',
  'Indian/Mauritius': 'MU',
  'Indian/Maldives': 'TF',
  'Africa/Blantyre': 'MW',
  'America/Mexico_City': 'MX',
  'America/Cancun': 'MX',
  'America/Merida': 'MX',
  'America/Monterrey': 'MX',
  'America/Matamoros': 'MX',
  'America/Chihuahua': 'MX',
  'America/Ciudad_Juarez': 'MX',
  'America/Ojinaga': 'MX',
  'America/Mazatlan': 'MX',
  'America/Bahia_Banderas': 'MX',
  'America/Hermosillo': 'MX',
  'America/Tijuana': 'MX',
  'Asia/Singapore': 'SG',
  'Asia/Kuala_Lumpur': 'MY',
  'Africa/Windhoek': 'NA',
  'Pacific/Noumea': 'NC',
  'Africa/Niamey': 'NE',
  'Pacific/Norfolk': 'NF',
  'America/Managua': 'NI',
  'Europe/Amsterdam': 'NL',
  'Europe/Oslo': 'NO',
  'Asia/Kathmandu': 'NP',
  'Pacific/Nauru': 'NR',
  'Pacific/Niue': 'NU',
  'Pacific/Chatham': 'NZ',
  'Asia/Muscat': 'OM',
  'America/Lima': 'PE',
  'Pacific/Tahiti': 'PF',
  'Pacific/Marquesas': 'PF',
  'Pacific/Gambier': 'PF',
  'Pacific/Bougainville': 'PG',
  'Asia/Manila': 'PH',
  'Asia/Karachi': 'PK',
  'Europe/Warsaw': 'PL',
  'America/Miquelon': 'PM',
  'Pacific/Pitcairn': 'PN',
  'Asia/Gaza': 'PS',
  'Asia/Hebron': 'PS',
  'Europe/Lisbon': 'PT',
  'Atlantic/Madeira': 'PT',
  'Atlantic/Azores': 'PT',
  'Pacific/Palau': 'PW',
  'America/Asuncion': 'PY',
  'Indian/Reunion': 'RE',
  'Europe/Bucharest': 'RO',
  'Europe/Kaliningrad': 'RU',
  'Europe/Moscow': 'RU',
  'Europe/Simferopol': 'UA',
  'Europe/Kirov': 'RU',
  'Europe/Volgograd': 'RU',
  'Europe/Astrakhan': 'RU',
  'Europe/Saratov': 'RU',
  'Europe/Ulyanovsk': 'RU',
  'Europe/Samara': 'RU',
  'Asia/Yekaterinburg': 'RU',
  'Asia/Omsk': 'RU',
  'Asia/Novosibirsk': 'RU',
  'Asia/Barnaul': 'RU',
  'Asia/Tomsk': 'RU',
  'Asia/Novokuznetsk': 'RU',
  'Asia/Krasnoyarsk': 'RU',
  'Asia/Irkutsk': 'RU',
  'Asia/Chita': 'RU',
  'Asia/Yakutsk': 'RU',
  'Asia/Khandyga': 'RU',
  'Asia/Vladivostok': 'RU',
  'Asia/Ust-Nera': 'RU',
  'Asia/Magadan': 'RU',
  'Asia/Sakhalin': 'RU',
  'Asia/Srednekolymsk': 'RU',
  'Asia/Kamchatka': 'RU',
  'Asia/Anadyr': 'RU',
  'Africa/Kigali': 'RW',
  'Indian/Mahe': 'SC',
  'Africa/Khartoum': 'SD',
  'Europe/Stockholm': 'SE',
  'Atlantic/St_Helena': 'SH',
  'Europe/Ljubljana': 'SI',
  'Arctic/Longyearbyen': 'SJ',
  'Europe/Bratislava': 'SK',
  'Africa/Freetown': 'SL',
  'Europe/San_Marino': 'SM',
  'Africa/Dakar': 'SN',
  'Africa/Mogadishu': 'SO',
  'America/Paramaribo': 'SR',
  'Africa/Juba': 'SS',
  'Africa/Sao_Tome': 'ST',
  'America/El_Salvador': 'SV',
  'America/Lower_Princes': 'SX',
  'Asia/Damascus': 'SY',
  'Africa/Mbabane': 'SZ',
  'America/Grand_Turk': 'TC',
  'Africa/Ndjamena': 'TD',
  'Indian/Kerguelen': 'TF',
  'Africa/Lome': 'TG',
  'Asia/Dushanbe': 'TJ',
  'Pacific/Fakaofo': 'TK',
  'Asia/Dili': 'TL',
  'Asia/Ashgabat': 'TM',
  'Africa/Tunis': 'TN',
  'Pacific/Tongatapu': 'TO',
  'Europe/Istanbul': 'TR',
  'America/Port_of_Spain': 'TT',
  'Pacific/Funafuti': 'TV',
  'Asia/Taipei': 'TW',
  'Africa/Dar_es_Salaam': 'TZ',
  'Europe/Kyiv': 'UA',
  'Africa/Kampala': 'UG',
  'Pacific/Midway': 'UM',
  'Pacific/Wake': 'UM',
  'America/New_York': 'US',
  'America/Detroit': 'US',
  'America/Kentucky/Louisville': 'US',
  'America/Kentucky/Monticello': 'US',
  'America/Indiana/Indianapolis': 'US',
  'America/Indiana/Vincennes': 'US',
  'America/Indiana/Winamac': 'US',
  'America/Indiana/Marengo': 'US',
  'America/Indiana/Petersburg': 'US',
  'America/Indiana/Vevay': 'US',
  'America/Chicago': 'US',
  'America/Indiana/Tell_City': 'US',
  'America/Indiana/Knox': 'US',
  'America/Menominee': 'US',
  'America/North_Dakota/Center': 'US',
  'America/North_Dakota/New_Salem': 'US',
  'America/North_Dakota/Beulah': 'US',
  'America/Denver': 'US',
  'America/Boise': 'US',
  'America/Los_Angeles': 'US',
  'America/Anchorage': 'US',
  'America/Juneau': 'US',
  'America/Sitka': 'US',
  'America/Metlakatla': 'US',
  'America/Yakutat': 'US',
  'America/Nome': 'US',
  'America/Adak': 'US',
  'Pacific/Honolulu': 'US',
  'America/Montevideo': 'UY',
  'Asia/Samarkand': 'UZ',
  'Asia/Tashkent': 'UZ',
  'Europe/Vatican': 'VA',
  'America/St_Vincent': 'VC',
  'America/Caracas': 'VE',
  'America/Tortola': 'VG',
  'America/St_Thomas': 'VI',
  'Asia/Ho_Chi_Minh': 'VN',
  'Pacific/Efate': 'VU',
  'Pacific/Wallis': 'WF',
  'Pacific/Apia': 'WS',
  'Asia/Aden': 'YE',
  'Indian/Mayotte': 'YT',
  'Africa/Lusaka': 'ZM',
  'Africa/Harare': 'ZW',
}
